import { CategoryScale, Chart } from "chart.js/auto"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import Layout from "../../layouts/layout"
import { Line } from "react-chartjs-2"
import { useState } from "react"
import { useRequestProcessor } from "../../api/requestProcessor"
import { getSiteRecord } from "../../api/dashboard"
import { domainName } from "../../constants/site"
import Loading from "../../components/loading/loading"

Chart.register(CategoryScale)


const Dashboard = () => {



    const { Query } = useRequestProcessor()

    const { data: siteData, isLoading, isSuccess } = Query(
        ['dashboard'],
        () => getSiteRecord()
    );


    

    const chartData ={
        labels: siteData?.data?.recordPrices?.map((data) => data.month),
        datasets: [
            {
                data: siteData?.data?.recordPrices?.map((data) => data.total),
                backgroundColor: [
                    "rgba(53, 162, 235, 0.3)"
                ],
                borderColor: "rgba(102, 126, 234, 1)",
                borderWidth: 2,
            }
        ]
    };


    return (
        <Layout>
            <MainPageLayout sectionTitle={"داشبورد"}>
                {
                    !isLoading && <>

                        <div className="flex pt-3">
                            <div className=" flex flex-col w-2/5 ml-4 justify-around transition-all ">
                                <div className="flex flex-col shadow-md hover:shadow-xl my-2 rounded-xl py-4 p-3">
                                    <h3 className="font-semibold">تعداد کاربران :</h3>
                                    <span className=" text-end px-4">{siteData?.data?.users}</span>
                                </div>
                                <div className="flex flex-col shadow-md my-2 hover:shadow-xl rounded-xl  py-4 p-3">
                                    <h3 className="font-semibold">تعداد کامنت ها :</h3>
                                    <span className=" text-end px-4">{siteData?.data?.comment}</span>
                                </div>
                                <div className="flex flex-col shadow-md my-2 hover:shadow-xl rounded-xl  py-4 p-3">
                                    <h3 className="font-semibold">تعداد تیکت ها :</h3>
                                    <span className=" text-end px-4">{siteData?.data?.tickets}</span>
                                </div>
                            </div>
                            <div className="flex flex-col w-full">
                                <div className="pr-4">
                                    <h1 className="font-bold text-lg pb-4">درآمد کلی : {siteData?.data?.totalPaid.toLocaleString()} تومان</h1>
                                    <p>نمودار کلی درآمد</p>
                                </div>
                                <Line data={chartData} options={{
                                    responsive: true,
                                    tension: 0.4,
                                    backgroundColor: "rgba(53, 162, 235, 0.3)",
                                    fill: "origin",
                                    plugins: {
                                        legend: {
                                            display: false
                                        }
                                    }
                                }} />
                            </div>
                        </div>
                        <div className="flex py-4 ">
                            {/* <div className="flex flex-col w-full ml-2 py-4 px-9 shadow-xl">
                                <div className="flex justify-between py-2 w-full">
                                    <p>
                                        تعداد بلاگ ها :
                                    </p>
                                    <p>100</p>
                                </div>
                                <div className="flex justify-between w-full py-2">
                                    <p>
                                        تعداد بازدید کلی بلاگ ها :
                                    </p>
                                    <p>100</p>
                                </div>
                            </div>
                            <div className="border-r-4"></div>
                            <div className="flex flex-col w-full mr-2 py-4 px-9 shadow-xl">
                                <div className="flex justify-between py-2 w-full">
                                    <p>
                                        تعداد ورک شاپ ها :
                                    </p>
                                    <p>100</p>
                                </div>
                                <div className="flex justify-between w-full py-2">
                                    <p>
                                        تعداد خرید کلی ورک شاپ ها :
                                    </p>
                                    <p>100</p>
                                </div>
                            </div> */}

                        </div>
                        <div className="flex flex-col py-4">
                            <h3 className="py-4 font-bold text-xl">وبلاگ ها با بیشترین بازدید : </h3>
                            <div className="grid !grid-cols-4 w-full gap-x-4">

                                {
                                    siteData?.data?.blogs?.map(el => (
                                        <div className="flex flex-col shadow-lg">
                                            <img src={domainName + el.cover_image} className="h-48" alt={el.title} />
                                            <div className="p-2">
                                                <h2 className="font-bold py-2">{el.title}</h2>
                                                <p className="py-2">تعداد بازدید : {el.viewCount}</p>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                        <div className="flex flex-col py-4">
                            <h3 className="py-4 font-bold text-xl">ورک شاپ ها با بیشترین تعداد شرکت کننده : </h3>
                            <div className="grid !grid-cols-4 w-full gap-x-4">
                                {
                                    siteData?.data?.workshops?.map(el => (
                                        <div className="flex flex-col shadow-lg">
                                            <img src={domainName + el.cover_image} className="h-48" alt={el.title} />
                                            <div className="p-2">
                                                <h2 className="font-bold py-2">{el.title}</h2>
                                                <p className="py-2">تعداد شرکت کننده : {el.registration_number}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="flex flex-col py-4">
                            <h3 className="py-4 font-bold text-xl">دوره ها با بیشترین تعداد شرکت کننده : </h3>
                            <div className="grid !grid-cols-4 w-full gap-x-4">
                                {
                                    siteData?.data?.courses_sell?.slice(0,Math.min(3, siteData?.data?.courses_sell?.length)).map(el => (
                                        <div className="flex flex-col shadow-lg">
                                            <img src={domainName + el.cover_image} className="h-48" alt={el.title} />
                                            <div className="p-2">
                                                <h2 className="font-bold py-2">{el.title}</h2>
                                                <p className="py-2">تعداد شرکت کننده : {el.count_sell}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="flex flex-col py-4">
                            <h3 className="py-4 font-bold text-xl">دوره ها با بیشترین تعداد بازدید : </h3>
                            <div className="grid !grid-cols-4 w-full gap-x-4">
                                {
                                    siteData?.data?.courses_view?.map(el => (
                                        <div className="flex flex-col shadow-lg">
                                            <img src={domainName + el.cover_image} className="h-48" alt={el.title} />
                                            <div className="p-2">
                                                <h2 className="font-bold py-2">{el.title}</h2>
                                                <p className="py-2">تعداد بازدید : {el.viewCount}</p>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </>
                }
                {
                    isLoading && <Loading />
                }
            </MainPageLayout>
        </Layout>
    )
}

export default Dashboard